import { useEffect } from 'react';

/**
 * Fecha um modal/overlay ao apertar ESC — usado por qualquer coisa que
 * abre "em tela cheia" (CartaoExpansivel, DesenhoGeometriaMapa, a matriz
 * de Importar Ficha de Campo). Só registra o listener enquanto `ativo`
 * for true, então overlays fechados não competem entre si.
 */
export function useFecharComEsc(ativo: boolean, aoFechar: () => void) {
  useEffect(() => {
    if (!ativo) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') aoFechar();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ativo]);
}
